import { render, staticRenderFns } from "./IdentificationChecksRules.vue?vue&type=template&id=401c3e45&scoped=true"
import script from "./IdentificationChecksRules.vue?vue&type=script&lang=js"
export * from "./IdentificationChecksRules.vue?vue&type=script&lang=js"
import style0 from "./IdentificationChecksRules.vue?vue&type=style&index=0&id=401c3e45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401c3e45",
  null
  
)

export default component.exports